export default __webpack_public_path__ + "media/color/vrc-49a21311.svg";